<script lang="ts">
	import HDStandings from '#lib/hockeydata/components/HDStandings.svelte';

	const { data } = $props();
</script>

<h2 class="mb-3">Tabelle</h2>
<HDStandings season={data.season} teamId={data.ownTeamId?.toString()} />
